import { RotatingLines } from "react-loader-spinner";

const ChartLoader = ({ isLoader }) => {
  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <RotatingLines
        strokeColor="grey"
        strokeWidth="5"
        animationDuration="0.75"
        width="72"
        visible={isLoader}
      />
    </div>
  );
};

export default ChartLoader;
